module.exports = __webpack_public_path__ + "static/img/o9m2.3fb45aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/o9m/o9m2.jpg
// module id = xUhY
// module chunks = 1